// extracted by mini-css-extract-plugin
export default {"featuredIn":"FeaturedIn_featuredIn__-p+88","content":"FeaturedIn_content__GcoQ3"};